export const PAGE_ITEMS_COUNT = 10